import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type MultiUsageSummary = components["schemas"]["MultiUsageSummary"];

/**
 * GET /v1/workspaces/me/usage — credit + basic-request quota for the period.
 * NOTE: distinct from `/v1/me/model-usage` (recent models for the chat picker).
 */
export async function getUsage(): Promise<MultiUsageSummary> {
  return unwrap(await api.GET("/v1/workspaces/me/usage"));
}
